export default "__VITE_ASSET__syX_kB_s__"